import { render, staticRenderFns } from "./BreakingBanner.vue?vue&type=template&id=47d1deb4&"
import script from "./BreakingBanner.vue?vue&type=script&lang=js&"
export * from "./BreakingBanner.vue?vue&type=script&lang=js&"
import style0 from "./BreakingBanner.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports